var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('a',{class:_vm.$style.app,attrs:{"href":_vm.url,"target":"_blank"}},[_c('component-image',{class:_vm.$style.image,attrs:{"aspect-ratio":_vm.aspectRatio,"image":_vm.icon}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }